/**
 * Product Vertical Slider Enhancement
 * 
 * This script enhances the gallery thumbnails to work better in a vertical layout.
 * It adjusts the scroll direction and focuses on proper alignment in vertical mode.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Only apply changes on desktop and tablet views
  const mediaQueryList = window.matchMedia('(min-width: 750px)');
  
  if (mediaQueryList.matches) {
    initVerticalSlider();
  }
  
  mediaQueryList.addEventListener('change', event => {
    if (event.matches) {
      initVerticalSlider();
    }
  });

  // Listen for media gallery updates (combined listings product swaps)
  document.addEventListener('product:media-gallery-updated', () => {
    if (mediaQueryList.matches) {
      initVerticalSlider();
    }
  });
  
  function initVerticalSlider() {
    // Find all thumbnail sliders in the product gallery
    const thumbnailSliders = document.querySelectorAll('[id^="GalleryThumbnails-"]');
    
    thumbnailSliders.forEach(slider => {
      // Only apply to product thumbnails
      if (!slider.classList.contains('thumbnail-slider')) return;

      // Create or get the counter element
      let counterElement = document.querySelector('.slider-counter.vertical-counter');
      if (!counterElement) {
        counterElement = document.createElement('div');
        counterElement.className = 'slider-counter vertical-counter caption';
        counterElement.innerHTML = `
          <span class="slider-counter--current">1</span>
          <span aria-hidden="true"> <svg width="15" height="2" viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.69 0.539999C0.69 0.427999 0.750666 0.371999 0.872 0.371999L14.69 0.358C14.746 0.358 14.788 0.367333 14.816 0.386C14.844 0.414 14.858 0.456 14.858 0.512L14.858 1.128C14.858 1.24 14.802 1.296 14.69 1.296L0.844 1.296C0.741333 1.296 0.69 1.24467 0.69 1.142L0.69 0.539999Z" fill="#E1E0DF"/>
            </svg>
          </span>
          <span class="slider-counter--total"></span>
        `;
        // Insert counter after the main gallery viewer
        const galleryViewer = document.querySelector('[id^="GalleryViewer-"]');
        if (galleryViewer) {
          galleryViewer.insertAdjacentElement('afterend', counterElement);
        }
      }

      // Handle thumbnail clicks and counter updates
      const thumbnailList = slider.querySelector('.thumbnail-list');
      const thumbnails = slider.querySelectorAll('.thumbnail-list__item');
      
      // Set total count
      const totalCount = thumbnails.length;
      counterElement.querySelector('.slider-counter--total').textContent = totalCount.toString();

      // Add click listeners to thumbnails
      thumbnails.forEach((thumbnail, index) => {
        const button = thumbnail.querySelector('button');
        if (!button) return;
        
        button.addEventListener('click', () => {
          if (window.innerWidth >= 750) {
            counterElement.querySelector('.slider-counter--current').textContent = (index + 1).toString();
          }
        });
      });

      // Override the isSlideVisible method for vertical scrolling
      if (slider.isSlideVisible) {
        const originalIsSlideVisible = slider.isSlideVisible;
        
        slider.isSlideVisible = function(element, offset = 0) {
          if (window.innerWidth >= 750) {
            const rect = element.getBoundingClientRect();
            const containerRect = this.getBoundingClientRect();
            
            return (
              rect.top >= containerRect.top - offset &&
              rect.bottom <= containerRect.bottom + offset
            );
          }
          return originalIsSlideVisible.call(this, element, offset);
        };
      }

      // Override the slider's scrollTo method to scroll vertically
      if (slider.slider && slider.slider.scrollTo) {
        const originalScrollTo = slider.slider.scrollTo;
        
        slider.slider.scrollTo = function(options) {
          if (window.innerWidth >= 750) {
            if (options.left !== undefined) {
              this.scrollTop = options.left;
              return;
            }
          }
          originalScrollTo.call(this, options);
        };
      }

      // Handle slider button clicks for vertical scrolling
      const prevButton = slider.querySelector('.slider-button--prev');
      const nextButton = slider.querySelector('.slider-button--next');
      
      if (prevButton && nextButton && thumbnailList) {
        const scrollAmount = 100;

        prevButton.addEventListener('click', () => {
          if (window.innerWidth >= 750) {
            thumbnailList.scrollTop = Math.max(0, thumbnailList.scrollTop - scrollAmount);
          }
        });

        nextButton.addEventListener('click', () => {
          if (window.innerWidth >= 750) {
            thumbnailList.scrollTop = Math.min(
              thumbnailList.scrollTop + scrollAmount,
              thumbnailList.scrollHeight - thumbnailList.clientHeight
            );
          }
        });

        // Update button states based on scroll position
        const updateButtonStates = () => {
          if (window.innerWidth >= 750) {
            const isAtTop = thumbnailList.scrollTop <= 0;
            const isAtBottom = thumbnailList.scrollTop + thumbnailList.clientHeight >= thumbnailList.scrollHeight;

            prevButton.disabled = isAtTop;
            nextButton.disabled = isAtBottom;
          }
        };

        thumbnailList.addEventListener('scroll', updateButtonStates);
        window.addEventListener('resize', updateButtonStates);
        updateButtonStates();
      }
    });
    
    // Override the setActiveThumbnail method in media-gallery components
    document.querySelectorAll('media-gallery').forEach(gallery => {
      if (gallery.setActiveThumbnail && typeof gallery.setActiveThumbnail === 'function') {
        const originalSetActiveThumbnail = gallery.setActiveThumbnail;
        
        gallery.setActiveThumbnail = function(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;
          
          this.elements.thumbnails
            .querySelectorAll('button')
            .forEach((element) => element.removeAttribute('aria-current'));
            
          thumbnail.querySelector('button').setAttribute('aria-current', true);

          // Update counter when active thumbnail changes
          if (window.innerWidth >= 750) {
            const thumbnails = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
            const index = Array.from(thumbnails).indexOf(thumbnail) + 1;
            const counter = document.querySelector('.slider-counter.vertical-counter');
            if (counter) {
              counter.querySelector('.slider-counter--current').textContent = index.toString();
            }
          }
          
          // Different behavior based on screen width
          if (window.innerWidth >= 750) {
            if (this.elements.thumbnails.slider) {
              const thumbnailRect = thumbnail.getBoundingClientRect();
              const containerRect = this.elements.thumbnails.getBoundingClientRect();
              
              if (thumbnailRect.top < containerRect.top || thumbnailRect.bottom > containerRect.bottom) {
                this.elements.thumbnails.scrollTop = thumbnail.offsetTop - 50;
              }
            }
          } else {
            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
            this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
          }
        };
      }
    });
  }
});
